import React from "react";
import { Accordion } from "flowbite-react";

const HeaderAccordionInstalacion = ({ instalacionsection, handleMenuSelection }) => {
  return (
    <Accordion collapseAll className="pdp-accordion">
      <Accordion.Panel>
        <Accordion.Title className="accordion-title">
          <button >Intalación</button>
        </Accordion.Title>
        <Accordion.Content>
          <a href="/manuales">Manuales</a>
          <button onClick={() => handleMenuSelection(instalacionsection)}>Videos de Instalación</button>
        </Accordion.Content>
      </Accordion.Panel>
    </Accordion>
  );
};

export default HeaderAccordionInstalacion;
